/**
 * Textos da exclusão de arquivo na aba Documentos (E216.F4, GUS-317 item 3): motivo e fundamento,
 * como na edição do exame; o original fica guardado e o histórico registra a exclusão.
 */
export const ptBRExclusaoNaMesa = {
  botao: 'Excluir',
  botaoDe: 'Excluir {nome} da análise',
  titulo: 'Excluir o arquivo da análise',
  descricao:
    'O arquivo sai da análise e o caso é preparado de novo sem ele. O original continua guardado com o mesmo SHA-256, o recibo de recebimento continua com ele, e o histórico do caso registra quem excluiu, quando, o motivo e o fundamento. A exclusão não se desfaz: para voltar a usar o arquivo, envie-o de novo por "Enviar documentos".',
  motivo: 'Motivo',
  motivos: {
    repetido: 'Arquivo repetido',
    outra_transacao: 'Arquivo de outro caso ou de outra transação',
    copia_sem_hash: 'Cópia sem hash declarado no arquivo de evidências',
    outro: 'Outro motivo',
  },
  fundamento: 'Fundamento',
  fundamentoAjuda:
    'Por que o arquivo sai (ao menos {minimo} caracteres). Fica no histórico do caso.',
  falta: {
    motivo: 'Escolha o motivo.',
    fundamento: 'Escreva o fundamento com pelo menos {minimo} caracteres.',
  },
  cancelar: 'Cancelar',
  confirmar: 'Excluir da análise',
  excluindo: 'Excluindo…',
  porQue: {
    contido:
      'Este documento saiu de um arquivo único. Exclua o arquivo de origem, que leva os documentos contidos nele.',
    certificacao: 'A CCB tem certificação em aberto e não pode ser excluída agora.',
    revisao:
      'O caso já tem revisão de Integridade ou Vínculo na seção 2 do exame, e excluir um arquivo mudaria as letras dessas linhas. Exclua os arquivos antes de revisar a seção 2.',
    nao_encontrado: 'O arquivo já foi excluído ou não está mais no caso. Atualize a lista.',
    falha: 'Não foi possível excluir o arquivo. Tente de novo.',
  },
} as const;
